<script setup lang="ts">
import { ref, computed, watch, reactive } from 'vue';
import adminAPI from '@/services/api';
import { computedAsync } from '@vueuse/core';
import draggable from 'vuedraggable';
import { formatUTCToLocalTime } from "@/utils/date";
import { FwbTab, FwbTabs } from 'flowbite-vue'

import { PaperClipIcon, InformationCircleIcon, DocumentPlusIcon, DocumentMagnifyingGlassIcon, TrashIcon, CloudIcon, LockOpenIcon }
  from '@heroicons/vue/24/outline';
  import { RadioGroup, RadioGroupLabel, RadioGroupOption, RadioGroupDescription } from '@headlessui/vue'


import BaseButton from '../ui/buttons/BaseButton.vue';
import { useClaimStore, useNotificationStore } from '@/store';
import { ClaimDocument, ListClaimGroups, RetrieveClaimWithRelationsResponse } from '@upclaim/sdk/src/data-contracts';
import DotLegalStep from '../ui/badges/DotLegalStep.vue';
import { BoxesIcon } from 'lucide-vue-next';
import { GripVerticalIcon } from 'lucide-vue-next';
import { UngroupIcon } from 'lucide-vue-next';
import BaseInput from '../ui/inputs/BaseInput.vue';
import { PencilLineIcon } from 'lucide-vue-next';
import { CombineIcon } from 'lucide-vue-next';
import router from '../../router';
import type { SearchClaimCollection, SearchClaimDocument } from "@upclaim/sdk/src/data-contracts";
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'
import { LockClosedIcon } from '@heroicons/vue/24/solid';
import { SaveIcon } from 'lucide-vue-next';
import DisplayClaimGroup from "./DisplayClaimGroup.vue";

const props = defineProps<{ claimId: string}>();

const claimGroups = reactive<{ groups: ListClaimGroups }>({ groups: [] });

watch(() => props.claimId,async () => {
  claimGroups.groups = await adminAPI.listClaimGroups(props.claimId)
  // Keep same active tab if possible
  activeTab.value = claimGroups.groups.some(({groupName}) => groupName === activeTab.value)
    ? activeTab.value
    : claimGroups.groups[0]?.groupName
}, { immediate: true })


const activeTab = ref('')
</script>
<template>


<div v-if="claimGroups?.groups?.length" class="p-2 bg-stone-50 border-y">
  <div class="w-full sm:px-0" :class="{ 'py-8': claimGroups.groups.length > 1 }">

    <fwb-tabs v-if="claimGroups.groups.length > 1" v-model="activeTab" variant="pills" class="w-full py-5">
      <fwb-tab v-for="(group, index) of claimGroups?.groups" :name="group.groupName" :title="group.groupName" :key="group.id">
        <DisplayClaimGroup :index="index" :group="group" />
      </fwb-tab>
    </fwb-tabs>
    <div v-else>
        <DisplayClaimGroup :index="0" :group="claimGroups?.groups[0]" />
    </div>
  </div>
</div>
</template>
